export const rxNumeroEntero = /^\d+$/;
export const rxNumedoDecimal2 = /^\d+(?:\.\d{1,2})?$/;
export const rxCorreo = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
export const rxUrl = /^(https?:\/\/)?(www\.)?(?![https?://]|\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
